import React from 'react';
import { fill } from './labels';
import ParticipantTable from './ParticipantTable';

// One hour slot: chip, count, share track, share %, and the participant table when open.
// An hour with no participants is not expandable (canvas hR8oo, state 4).
export default function HourRow({
  block, isOpen, isExpandedRows, onToggle, onShowAll, labels
}) {
  var isEmpty = block.count === 0;

  function handleKeyDown(event) {
    if (isEmpty) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle(block.hour);
    }
  }

  return (
    <div className={'ehc-monitoring__hour' + (isEmpty ? ' ehc-monitoring__hour--empty' : '')}>
      <div
        className="ehc-monitoring__hour-header"
        role="button"
        tabIndex={isEmpty ? -1 : 0}
        aria-expanded={isOpen}
        aria-disabled={isEmpty}
        onClick={isEmpty ? undefined : function () { onToggle(block.hour); }}
        onKeyDown={handleKeyDown}
      >
        <span className="ehc-monitoring__hour-chip">{block.hour_label}</span>
        <span className="ehc-monitoring__hour-count">
          {isEmpty ? labels.empty_hour : fill(labels.count, { count: block.count })}
        </span>
        <span className="ehc-monitoring__track">
          <span
            className={'ehc-monitoring__track-fill ehc-monitoring__track-fill--w-' +
              Math.round((block.share || 0) / 5) * 5}
          />
        </span>
        <span className="ehc-monitoring__hour-pct">{isEmpty ? '—' : block.share + '%'}</span>
        <i className={'zmdi zmdi-chevron-' + (isOpen ? 'up' : 'down')} />
      </div>

      {isOpen && !isEmpty && (
        <ParticipantTable
          participants={block.participants}
          expanded={isExpandedRows}
          onShowAll={function () { onShowAll(block.hour); }}
          labels={Object.assign({}, labels.table, { show_more: labels.show_more })}
        />
      )}
    </div>
  );
}
